import type { AccountInvite } from '../../../redux/types.ts';
import type { FC } from 'react';
import React, { useState } from 'react';
import cn from 'classnames';
import styles from './notifications.module.scss';
import IfxButton from '../../../views/common/IfxButton.tsx';
import { useTranslation } from 'react-i18next';
import { UsersIcon } from '@phosphor-icons/react/dist/csr/Users';

const {
  accountInviteNotification,
  notificationIcon,
  notificationContent,
  notificationType,
  notificationText,
  notificationAction,
  bold,
} = styles;

type InvitationNotificationProps = {
  invite: AccountInvite;
  onAccept: (invite: AccountInvite) => void;
  onReject: (invite: AccountInvite) => void;
};

const InvitationNotification: FC<InvitationNotificationProps> = ({ invite, onAccept, onReject }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'notifications.invitation' });
  const [isActive, setIsActive] = useState(false);

  const onCardClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const onRejectHandler = () => {
    setIsActive(true);
    onReject(invite);
  };

  const onAcceptHandler = () => {
    setIsActive(true);
    onAccept(invite);
  };

  return (
    <div className={cn(accountInviteNotification, { notificationActive: isActive })} onClick={onCardClick}>
      <div className={notificationIcon}>
        <UsersIcon size={24} />
      </div>
      <div className={notificationContent}>
        <div className={notificationType}>{t('pending')}</div>
        <div className={notificationText}>
          {t('group')}: <span className={bold}>{invite.groupName}</span>
        </div>
        <div className={notificationText}>
          {t('account')}:{' '}
          <span className={bold}>
            {invite.accountId} - {invite.accountName}
          </span>
        </div>
        <div className={notificationAction}>
          <IfxButton disabled={isActive} size="small" variant="text" color="error" onClick={onRejectHandler}>
            {t('reject')}
          </IfxButton>
          <IfxButton disabled={isActive} size="small" variant="text" onClick={onAcceptHandler}>
            {t('accept')}
          </IfxButton>
        </div>
      </div>
    </div>
  );
};

export default InvitationNotification;
